import { Accordion } from "components/ui/accordion";
import TaskItem from "pages/CaseDetail/components/Tasks/TaskItem";
import { TaskHandlers } from "pages/CaseDetail/components/Tasks/types";
import { CaseTask } from "pages/CaseDetail/types";

interface TaskGroupProps extends TaskHandlers {
  title: string;
  tasks: CaseTask[];
}

const TaskGroup = ({ title, tasks, ...handlers }: TaskGroupProps) => (
  <div>
    <h3 className="bg-brand-gray px-6 py-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
      {title}
    </h3>
    <Accordion
      defaultValue={tasks
        .filter((task) => task.status === "OPEN")
        .map((task) => task.uuid)}
      type="multiple"
      className="divide-y"
    >
      {tasks.map((task) => (
        <TaskItem key={task.uuid} task={task} {...handlers} />
      ))}
    </Accordion>
  </div>
);

export default TaskGroup;
